// components/ui/Pagination/index.tsx
// Thuần UI — nhận state từ ngoài, emit events

interface PaginationProps {
  currentPage: number
  totalPages: number
  totalCount: number
  startIndex: number
  endIndex: number
  getPageNumbers: () => (number | '...')[]
  onPageChange: (page: number) => void
  onPrev: () => void
  onNext: () => void
  className?: string
}

const Pagination = ({
  currentPage,
  totalPages,
  totalCount,
  startIndex,
  endIndex,
  getPageNumbers,
  onPageChange,
  onPrev,
  onNext,
  className = '',
}: PaginationProps) => {
  if (totalPages <= 1 || totalCount === 0) return null

  return (
    <div className={`pagination-wrapper ${className}`}>
      <div className="pagination" role="navigation" aria-label="Phân trang">
        {/* Nút Previous */}
        <button
          className="pagination-btn pagination-btn-icon"
          onClick={onPrev}
          disabled={currentPage === 1}
          aria-label="Trang trước"
        >
          <i className="fas fa-chevron-left" />
        </button>

        {/* Thông tin trang trên mobile */}
        <span className="pagination-mobile-info">
          Trang {currentPage} / {totalPages}
        </span>

        {/* Các số trang */}
        {getPageNumbers().map((page, index) =>
          page === '...' ? (
            <span key={`ellipsis-${index}`} className="pagination-ellipsis">
              •••
            </span>
          ) : (
            <button
              key={page}
              className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
              onClick={() => onPageChange(page as number)}
              aria-label={`Trang ${page}`}
              aria-current={currentPage === page ? 'page' : undefined}
            >
              {page}
            </button>
          )
        )}

        {/* Nút Next */}
        <button
          className="pagination-btn pagination-btn-icon"
          onClick={onNext}
          disabled={currentPage === totalPages}
          aria-label="Trang sau"
        >
          <i className="fas fa-chevron-right" />
        </button>
      </div>

      <p className="pagination-info">
        Hiển thị <strong>{startIndex + 1}–{endIndex}</strong> trong{' '}
        <strong>{totalCount}</strong> dự án
      </p>
    </div>
  )
}

export default Pagination
